import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=52f8ff2d&scoped=true&"
import script from "./faq.vue?vue&type=script&lang=js&"
export * from "./faq.vue?vue&type=script&lang=js&"
import style0 from "./faq.vue?vue&type=style&index=0&id=52f8ff2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f8ff2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f8ff2d')) {
      api.createRecord('52f8ff2d', component.options)
    } else {
      api.reload('52f8ff2d', component.options)
    }
    module.hot.accept("./faq.vue?vue&type=template&id=52f8ff2d&scoped=true&", function () {
      api.rerender('52f8ff2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/faq.vue"
export default component.exports